import axiosClient from "@shared/Axios/client";

const endPoint = "customer";
export const AuthServices = {
    login: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/login`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    register: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/register`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    verifyOtp: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/verifyOtp`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    changeEmailOrPhone: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/changeEmailOrPhone`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    checkCustomer: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/checkCustomer`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    changePassword: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/changePassword`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    verifyRecaptcha: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/verifyRecaptcha`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

};